export const path = "/ready-leads-demand";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "READY LEADS DEMAND",
  section: "HOP",
  group: null,
  order: 3,
  roles: [
    "Authenticated",
    "hop-management",
    "hop-publisher-partnerships",
  ],
};
